import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'; // * Provide `as` support

var BreadcrumbWrapper = styled.div.withConfig({
  displayName: "Breadcrumbs__BreadcrumbWrapper",
  componentId: "sc-qs4clx-0"
})([""]); // Zeplin mocks may still show #999999 for inactive, #676767 is AA compliant

var BreadcrumbItem = styled.span.withConfig({
  displayName: "Breadcrumbs__BreadcrumbItem",
  componentId: "sc-qs4clx-1"
})(["\n  margin: 0;\n  color: ", ";\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  font-style: inherit;\n  line-height: inherit;\n\n  ", ";\n"], p => p.isActive ? "#222222" : "#676767", _ref => {
  var itemStyle = _ref.itemStyle;
  return itemStyle;
});
var Breadcrumbs = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var activeElementType = _ref2.activeElementType,
      _ref2$enableTrailingD = _ref2.enableTrailingDelimiter,
      enableTrailingDelimiter = _ref2$enableTrailingD === void 0 ? false : _ref2$enableTrailingD,
      itemStyle = _ref2.itemStyle,
      labels = _ref2.labels,
      _ref2$delimiter = _ref2.delimiter,
      delimiter = _ref2$delimiter === void 0 ? " / " : _ref2$delimiter,
      rest = _objectWithoutProperties(_ref2, ["activeElementType", "enableTrailingDelimiter", "itemStyle", "labels", "delimiter"]);

  return /*#__PURE__*/React.createElement(BreadcrumbWrapper, _extends({
    ref: ref
  }, rest), labels.map((label, index) => {
    var layerNum = index + 1;
    var isActive = layerNum === labels.length;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(BreadcrumbItem, {
      "data-autotag": "grid-breadcrumb-layer-".concat(layerNum),
      isActive: isActive,
      as: isActive ? activeElementType : undefined,
      itemStyle: itemStyle
    }, label), (!isActive || enableTrailingDelimiter) && delimiter);
  }));
}));
Breadcrumbs.BreadcrumbItem = BreadcrumbItem;
Breadcrumbs.propTypes = {
  /**
   * Pass this to override the element type (for example, `h1`) that the active
   * breadcrumb item renders as.
   */
  activeElementType: PropTypes.elementType,

  /**
   * The delimiter to use between items.
   */
  delimiter: PropTypes.node,

  /**
   * Enabling this boolean forces the delimiter to render after the final breadcrumb
   * item.
   */
  enableTrailingDelimiter: PropTypes.bool,
  itemStyle: PropTypes.any,

  /**
   * The breadcrumb items. The item at the top of the stack is
   * treated as the most nested (and current) breadcrumb in the chain.
   */
  labels: PropTypes.arrayOf(PropTypes.node).isRequired
};
Breadcrumbs.displayName = 'Breadcrumbs';
export default Breadcrumbs;